import {Box, BoxProps} from '@chakra-ui/react';
import {FC, PropsWithChildren} from 'react';

import {Section} from '..';

interface IProps {
  title: string;
  sectionId: string;
  sectionStyle?: BoxProps;
  titleStyle?: BoxProps;
}

export const SectionProvider: FC<PropsWithChildren<IProps>> = ({
  sectionStyle,
  children,
  title,
  sectionId,
  titleStyle,
}) => {
  return (
    <Box
      as="section"
      id={sectionId}
      mb="50px"
      mt="30px"
      _before={{
        content: '" "',
        display: 'block',
        top: 0,
        h: '190px',
        mt: '-220px',
        w: '100%',
      }}
    >
      <Section title={title} borderRadius="16px" {...sectionStyle} titleStyle={titleStyle}>
        {children}
      </Section>
    </Box>
  );
};
